
import axios from "axios";
import querystring from 'querystring';
import { toast} from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom";


const AgentLogin = ({handleInput, agent, handleTogglePage}) => {

    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            console.log(agent);
            const {email,password} = agent;
            
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}agent-login`,
                querystring.stringify({email,password})
            );
            if(res.data.success){
                toast.success('Login successfully.', {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                localStorage.setItem('agent_auth_token',res?.data?.token);
                setTimeout(() => {
                    history.push('/agent-dashboard');
                }, 2500)

                return;
            }
            else{
                toast.error(res?.data?.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                });
                return;
            }

        } catch (error) {
            console.log(error?.response?.data?.message);
            toast.error(error?.response?.data?.message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
                theme: "colored",
            });
        }
    }

    return (
        <div className="portal-form-wrapper">
            <form className="portal-form" onSubmit={handleSubmit}>
                <h3 className="portal-form-heading">Agent Login</h3>
                <div className="portal-input-group">
                    <input required name="email" type="email"  placeholder="Enter email..." onChange={handleInput}/>
                    <input required name="password" type="password" placeholder="Enter password...." onChange={handleInput}/>
                </div>
                <div className="w-full text-center my-3">
                    <span>Don't have an account?&nbsp; 
                        <span>
                            <a onClick={()=>{handleTogglePage('signup')}} className="page-toggle-link">
                                Signup
                            </a>
                        </span>
                        <span>&nbsp;to create a new account.</span>
                    </span>
                </div>
                <div className="portal-form-btn-group">
                    <button type="submit">Login</button>
                </div>
            </form>
        </div>
    );


}


export default AgentLogin;